<template>
  <div class="animated fadeIn">
    <div>
      <vue-good-table
        :columns="columns"
        :rows="consultations"
        :search-options="{
          enabled: true,
          skipDiacritics: true,
          placeholder: 'Recherchez dans tous le tableau',
         }"
      >

        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'details'">
                <button type="button" class="btn btn-primary" @click="detailsConsultations(props.row)">
                      Voir détails de l'offre
                </button>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
        </template>

      </vue-good-table>

      <el-dialog
        title="Details de l'offre"
        :visible.sync="detailsConsultationsVisible"
        width="85%"
        center>
        <span>
          <el-card class="box-card">
            <el-row>
              <el-col :span="12" class="primary">
                <b>Titre:</b>
              </el-col>
              <el-col :span="12">
                <el-input readonly :value="current.titre"/>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="primary">
                <b>Date Limite:</b>
              </el-col>
              <el-col :span="12">
                <el-date-picker readonly type="date" placeholder="Date Limite" v-model="current.date_limite"
                 value-format="yyyy-MM-dd"
                 style="width: 100%;"></el-date-picker>
              </el-col>
            </el-row>
            <div style="margin-bottom:5px"></div>
            <el-row>
              <el-col :span="12" class="primary">
                <b>Télécharger document attaché :</b>
              </el-col>
              <el-col :span="12">
                <el-button @click="downloadConsultation" plain icon="el-icon-download" type="primary">Télécharger</el-button>                
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12" class="primary">
                <b>Contact:</b>
              </el-col>
              <el-col :span="12">
                <el-input readonly :value="current.contact"/>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12" class="primary">
                <b>Description:</b>
              </el-col>
              <el-col :span="12">
                
              </el-col>
            </el-row>
            <!-- <el-row> -->
              <!-- <el-input readonly type="textarea" :value="current.description"/> -->
              {{current.description}}
            <!-- </el-row> -->
          </el-card>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="detailsConsultationsVisible = false">Fermer</el-button>
          <!-- <el-button type="primary" @click="centerDialogVisible = false">Confirmer</el-button> -->
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';



export default {
  name: 'consultations',

  data: function () {
    return {
      current:{},
      columns:[
        {
          label:"Titre",
          field:"titre",
          filterOptions: {
            enabled: true, 
            placeholder: '', 
          },
        },
        {
          label:"Date Limite",
          field:"date_limite",
          filterOptions: {
            enabled: true, 
            placeholder: '', 
          },
        },
        {
          label:"Actions",
          field:"details"
        },
      ],
      rows:[

      ],
      detailsConsultationsVisible:false
    }
  },
  methods:{
     ...mapActions([
      'getConsultations'
    ]),
    detailsConsultations(props){
      console.log('props :', props);
      this.current = props;
      this.detailsConsultationsVisible = true
    },
    downloadConsultation(){
      window.open(this.current.chemin_fichier,'_blank');
    }
  },
  computed:{
   ...mapState({
     consultations:state=>state.offres.consultations
   })
  },
  mounted(){
    // this.getMessages()
    console.log('boom');
    this.getConsultations()/* .then(res=>{
      this.consultations.push({
        delete:e=>{console.log('boom');}
      })
    }) */;
  }
}
</script>


<style scoped>
  .fade-enter-active {
    transition: all .3s ease;
  }
  .fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>